import ReactMultiSelect, { GroupBase, Props } from "react-select";

const MultiSelect = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: Props<Option, IsMulti, Group>,
) => {
  const { styles, ...otherProps } = props;
  return (
    <ReactMultiSelect
      styles={{
        ...styles,
        container: (baseStyles) => ({
          ...baseStyles,
          width: "100%",
          textAlign: "left",
          borderColor: "white",
        }),
        control: (baseStyles) => ({
          ...baseStyles,
          backgroundColor: "darkBlue2.800",
        }),
        valueContainer: (baseStyles) => ({
          ...baseStyles,
          paddingLeft: "12px",
        }),
        dropdownIndicator: (baseStyles) => ({
          ...baseStyles,
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          backgroundColor: "#20213c",
          boxShadow: "0 7px 14px 0 rgba(0, 0, 0, 0.16)",
          borderRadius: "16px",
        }),
        placeholder: (baseStyles) => ({
          ...baseStyles,
          color: "white",
          fontSize: "16px",
        }),
        input: (baseStyles) => ({
          ...baseStyles,
          color: "white",
        }),
        singleValue: (baseStyles) => ({
          ...baseStyles,
          color: "white",
        }),
        option: (baseStyles, { isFocused, isSelected }) => ({
          ...baseStyles,
          backgroundColor: isSelected
            ? "#fcde1a" // Background color for selected option
            : isFocused
              ? "#fffccacc" // Background color for highlighted option
              : undefined,
          color: isSelected || isFocused ? "#1f2349" : "#CFD6E1",
        }),
      }}
      {...otherProps}
    />
  );
};

export default MultiSelect;
